<template>
    <div v-if="isVisible" class="fixed inset-0 bg-gray-600 bg-opacity-70 z-50 flex justify-center items-center p-4">
      <div class="bg-white dark:bg-gray-800 p-6 rounded-lg w-full max-w-md">
        <h2 class="text-lg font-semibold dark:text-gray-100 mb-4">Add New User</h2>
        <div class="space-y-4">
          <div v-if="errors.firstName" class="text-red-500 text-xs">{{ errors.firstName }}</div>
          <input type="text" v-model="newUser.firstName" class="w-full p-2 rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-400 dark:border-gray-600 dark:text-gray-100" placeholder="First Name" :class="{ 'dark:border-red-600 border-red-600': errors.firstName }"/>
          <div v-if="errors.lastName" class="text-red-500 text-xs">{{ errors.lastName }}</div>
          <input type="text" v-model="newUser.lastName" class="w-full p-2 rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-400 dark:border-gray-600 dark:text-gray-100" placeholder="Last Name" :class="{ 'dark:border-red-600 border-red-600': errors.lastName}"/>
          <div v-if="errors.email" class="text-red-500 text-xs">{{ errors.email }}</div>
          <div class="flex items-center space-x-2">
            <div class="relative w-full">
              <input  type="email"
                class="block pt-2 pl-2 pb-2 w-full rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-400 dark:border-gray-600 dark:text-gray-100"
                placeholder="Email" v-model="newUser.email" :class="{ 'dark:border-red-600 border-red-600': errors.email }"/>
              <button v-if="newUser.email != ''" @click="clearEmail"
                class="absolute right-2 top-1/2 transform -translate-y-1/2 text-gray-500 hover:text-red-500">
                <svg class="h-5 w-5" fill="currentColor" viewBox="0 0 24 24">
                  <path d="M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                  <path d="M6 6L18 18" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
                </svg>
              </button>
            </div>
            <button
              type="button"
              @click="prefillEmail"
              class="px-3 py-2 text-xs font-semibold rounded-md bg-gray-200 hover:bg-gray-300 dark:bg-gray-600 dark:hover:bg-gray-500 dark:text-gray-100"
            >
              Prefill
            </button>
          </div>
          <div v-if="errors.phone" class="text-red-500 text-xs">{{ errors.phone }}</div>
          <div class="flex space-x-2">
            <input type="text" v-model="newUser.phone" class="flex-1 p-2 rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-400 dark:border-gray-600 dark:text-gray-100"  placeholder="e.g., 1234567890, (123) 456-7890, or +1 123 456 7890" :class="{ 'dark:border-red-600 border-red-600': errors.phone}"/>
            <input type="text" v-model="newUser.extension" class="w-24 p-2 rounded-md border-gray-300 shadow-sm text-xs dark:bg-gray-400 dark:border-gray-600 dark:text-gray-100" placeholder="Ext." />
          </div>
        </div>
        <div class="flex justify-end space-x-2 mt-4">
          <button @click="addUser" class="bg-blue-500 hover:bg-blue-700 text-white font-bold py-2 px-4 rounded dark:bg-blue-400 dark:hover:bg-blue-600">Add</button>
          <button @click="closeModal()" class="bg-red-500 hover:bg-red-700 text-white font-bold py-2 px-4 rounded dark:bg-red-400 dark:hover:bg-red-600">Close</button>
        </div>
      </div>
    </div>
  </template>
  
  <script>
  export default {
    props: {
    isVisible: Boolean,
  },
  data() {
    return {
      newUser: {
          firstName: '',
          lastName: '',
          email: '',
          phone: '',
          extension: '',
        },
        errors: {
          firstName: null,
          lastName: null,
          email: null,
          phone: null,
        },
    };
  },
  methods: {
    closeModal() {
      this.newUser = { firstName: '', lastName: '', email: '', phone: '', extension: '' };
      this.errors = { firstName: '', lastName: '', email: '', phone: '' };
      this.$emit("close");
    },
    clearEmail() {
      this.newUser.email = '';
      this.errors.email = null;
    },
    prefillEmail() {
      this.newUser.email = 'pbx@aimitservices.com';
      this.errors.email = null;
    },
    validateForm() {
      let valid = true;

      // First name validation: must not be empty
      if (!this.newUser.firstName) {
        this.errors.firstName = 'First name is required';
        valid = false;
      } else {
        this.errors.firstName = null;
      }

      // Last name validation: must not be empty
      if (!this.newUser.lastName) {
        this.errors.lastName = 'Last name is required';
        valid = false;
      } else {
        this.errors.lastName = null;
      }

      // Email validation: must be in correct format
      const emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!this.newUser.email || !emailPattern.test(this.newUser.email)) {
        this.errors.email = 'Please enter a valid email address';
        valid = false;
      } else {
        this.errors.email = null;
      }

      // Phone number validation: must be in correct format
      // Example pattern: validate US phone number format
      const phonePattern = /^(\+1\s?)?(\(?\d{3}\)?[\s.-]?)?\d{3}[\s.-]?\d{4}$/;
      if (this.newUser.phone && !phonePattern.test(this.newUser.phone.replace(/\s/g, ''))) {
        this.errors.phone = 'Invalid format. Use 1234567890, 123-456-7890, (123) 456-7890 or +1 123 456 7890';
        valid = false;
      } else {
        this.errors.phone = null;
      }

      return valid;
    },
    addUser() {
      // Display the alert with the user information
      // const confirmation = confirm(`New User will be Added:\nName: ${this.newUser.firstName} ${this.newUser.lastName}\nEmail: ${this.newUser.email}\nPhone: ${this.newUser.phone}\n\nPress OK to add or Cancel to edit.`);
      // if (confirmation) {
      //   // Logic to add the user to the user table goes here
      //   this.$emit("complete", {
      //       newUser: this.newUser
      //   });
      //   // Reset the newUser object
      //   this.newUser = { firstName: '', lastName: '', email: '', phone: '' };
      // } else {
        
      // }
      if (this.validateForm()) {
        this.$emit("complete", {
            newUser: this.newUser
        });
        // Reset the newUser object
        this.newUser = { firstName: '', lastName: '', email: '', phone: '', extension: '' };
        this.errors = { firstName: '', lastName: '', email: '', phone: '' };
      }
    }
  },
};
  </script>
  